import React from 'react';

import { connect } from 'react-redux';
import { Collapse, Spin } from 'antd';
import { bindActionCreators } from 'redux';
import {
  Box, ShowIf, Text,
} from '../../shared/components';
import {
  seleccionarCaracteristicaFiltrado,
  obtenerFiltrosFromDB,
  cambiarPanelActivo,
  inicializarFormulario,
} from '../../../state/actions/creators/pel.actioncreator';
import ConfiguracionLentePanel from '../components/dataEntry/ConfiguracionLentePanel';
import FiltroDatosMontura from '../components/dataEntry/FiltroDatosMontura';
import { deepClone } from '../../../helpers/object.helper';

const { Panel } = Collapse;

class PELFiltro extends React.Component {
  componentDidMount() {
    const {
      obtenerFiltrosFromDB, sagas, inicializarFormulario, inicializado,
    } = this.props;
    const { LENTES_PEL_MIS_CATALOGOS } = sagas;
    const { success: catalogosCargados } = LENTES_PEL_MIS_CATALOGOS || { success: false };
    if (catalogosCargados === false || inicializado === false) {
      obtenerFiltrosFromDB();
    }
  }

  seleccionarCaracteristica(configuracion, caracteristica) {
    const { seleccionarCaracteristicaFiltrado, permisos } = this.props;
    seleccionarCaracteristicaFiltrado(configuracion, caracteristica, permisos);
  }

  seleccionesSeparadasPorComa({ configuracion }) {
    const {
      id, multiselect,
    } = configuracion;
    const { pel } = this.props;
    const { filtrador } = pel;
    const { selecciones: filtrosSeleccionados } = filtrador;
    let nombreCaracteristicaSeleccionada = '';
    const caracteristicasSeleccionadas = filtrosSeleccionados[id];

    if (caracteristicasSeleccionadas) {
      if (multiselect) {
        Object.keys(caracteristicasSeleccionadas).map((clave) => {
          const caracteristicaSeleccionada = caracteristicasSeleccionadas[clave];
          const { nombre } = caracteristicaSeleccionada;
          nombreCaracteristicaSeleccionada += `${nombre}, `;
          return true;
        });
        nombreCaracteristicaSeleccionada = nombreCaracteristicaSeleccionada.replace(/,\s*$/, '');
      } else {
        const { nombre } = caracteristicasSeleccionadas;
        nombreCaracteristicaSeleccionada = nombre;
      }
    }
    return nombreCaracteristicaSeleccionada;
  }

  render() {
    const {
      pel, sagas, cambiarPanelActivo, panelesOcultos, puedeElegirCatalogo, mostrarErroresMontura, dnpObligatorio,
    } = this.props;
    const { filtrador, viene_de, usaMiCatalogo } = pel;
    const { formulario, selecciones, panelActivo, faltanDatosMontura, botonBusquedaEnabled } = filtrador;
    const { LENTES_PEL_MIS_CATALOGOS } = sagas;
    const { running: cargandoPeticionDeCatalogos, success: cargarPeticionDeCatalogoExitosa } = LENTES_PEL_MIS_CATALOGOS || { running: false, success: false };
    const mostrarCargando = cargandoPeticionDeCatalogos;
    const { montura: monturaSeleccionada, graduacion: graduacionSeleccionada } = selecciones;
    const {
      precargada: monturaPrecargada, calibre, puente, tipoMontura, descripcion: monturaDescripcion,
    } = monturaSeleccionada;
    const { precargada: graduacionPrecargada, derecho: { DNPL: dnp } } = graduacionSeleccionada;

    const selectores = Object.keys(formulario).map((clave) => {
      const configuracion = formulario[clave];
      const {
        id, nombre, multiselect, opciones, disabled,
      } = configuracion;
      if (viene_de === 'encargo' && id === 'grosores') return null;
      if (viene_de !== 'presupuesto' && id === 'tratamientos') return null;
      if (!puedeElegirCatalogo && id === 'catalogo') return null;
      const caracteristicasSeleccionadas = selecciones[id];
      const nombreCaracteristicaSeleccionada = this.seleccionesSeparadasPorComa({ configuracion });
      const tieneSeleccion = caracteristicasSeleccionadas !== undefined;
      return (
        <Panel
          disabled={disabled}
          key={id}
          header={(
            <Box>
              <Text fontWeight="bold">
                { nombre}
                <ShowIf condition={tieneSeleccion}>:</ShowIf>
              </Text>
              <Text ml="4">{nombreCaracteristicaSeleccionada}</Text>
            </Box>
          )}
        >
          <ConfiguracionLentePanel
            key={id}
            configuracion={configuracion}
            multiselect={(id !== 'grosores' || viene_de !== 'encargo') ? multiselect : false}
            onSelectCaracteristica={
              (configuracion, caracteristica) => this.seleccionarCaracteristica(configuracion, caracteristica)
            }
            caracteristicasSeleccionadas={caracteristicasSeleccionadas}
            opciones={opciones}
          />
        </Panel>
      );
    });

    let panelMontura;
    if (panelesOcultos === undefined || !panelesOcultos.includes('montura')) {
      panelMontura = (
        <Panel
          key="montura"
          header={(
            <Box>
              <Text fontWeight="bold">
                Montura
                <ShowIf condition={monturaDescripcion !== null}>:</ShowIf>
              </Text>
              <Text ml="4">{monturaDescripcion}</Text>
            </Box>
          )}
        >
          <FiltroDatosMontura
            required={mostrarErroresMontura}
            calibreEditable={monturaPrecargada === false}
            puenteEditable={monturaPrecargada === false}
            tipoMonturaEditable={monturaPrecargada === false}
            dnpEditable={!dnpObligatorio || graduacionPrecargada === false}
            calibre={calibre}
            puente={puente}
            dnp={dnp}
            tipoMontura={tipoMontura}
            onChangeCalibre={(calibre) => {
              const monturaSeleccionadaModificada = deepClone(monturaSeleccionada);
              monturaSeleccionadaModificada.calibre = calibre;
              this.seleccionarCaracteristica({
                nombre: 'montura',
                id: 'montura',
              }, monturaSeleccionadaModificada);
            }}
            onChangePuente={(puente) => {
              const monturaSeleccionadaModificada = deepClone(monturaSeleccionada);
              monturaSeleccionadaModificada.puente = puente;
              this.seleccionarCaracteristica({
                nombre: 'montura',
                id: 'montura',
              }, monturaSeleccionadaModificada);
            }}
            onChangeDNP={(dnp) => {
              const graduacionSeleccionadaModificada = deepClone(graduacionSeleccionada);
              graduacionSeleccionadaModificada.derecho.DNPL = dnp;
              graduacionSeleccionadaModificada.izquierdo.DNPL = dnp;
              this.seleccionarCaracteristica({
                nombre: 'graduacion',
                id: 'graduacion',
              }, graduacionSeleccionadaModificada);
            }}
            onChangeTipoMontura={(tipoMontura) => {
              const monturaSeleccionadaModificada = deepClone(monturaSeleccionada);
              monturaSeleccionadaModificada.tipoMontura = tipoMontura;
              this.seleccionarCaracteristica({
                nombre: 'montura',
                id: 'montura',
              }, monturaSeleccionadaModificada);
            }}
          />
        </Panel>
      );
    }

    return (
      <Box>
        <style>
          {
            '.ant-collapse-header{ margin-left: 16px; }'
          }
        </style>
        <Spin tip="Cargando PEL" spinning={mostrarCargando || !cargarPeticionDeCatalogoExitosa}>
          <Box>
            <Collapse
              bordered={false}
              accordion
              activeKey={panelActivo}
              onChange={(e) => {
                cambiarPanelActivo({ panelActivo: e });
              }}
            >
              {selectores}
              {panelMontura}
            </Collapse>
          </Box>
        </Spin>
      </Box>
    );
  }
}

const mapStateToProps = ({ pel, sagas, auth }) => ({
  pel,
  sagas,
  permisos: auth.permisos,
  inicializado: pel.inicializado,
  puedeElegirCatalogo: pel.puedeElegirCatalogo,
  dnpObligatorio: pel.dnpObligatorio,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    seleccionarCaracteristicaFiltrado,
    obtenerFiltrosFromDB,
    cambiarPanelActivo,
    inicializarFormulario,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PELFiltro);
